module.exports = __webpack_public_path__ + "img/krabot.c43387fd.jpg";